import declare from "dojo/_base/declare";
import New from "csi/table/New";
import { ViewWidget } from "csi/view/Widget";

const DataPackageTemplateParentSheet = declare(New, {
	onCreatePopup: function(view: ViewWidget) {
		view.defView.classControllerParams = { forParent: true };
		this.inherited(arguments);
	},
});

export = DataPackageTemplateParentSheet;